import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "~/components/ui/accordion";

const FAQ_ITEMS = [
  "triggers",
  "frequency",
  "synced_data",
  "battery_alerts",
  "dtc",
  "requirements",
  "tokens",
  "troubleshooting",
  "security",
] as const;

export function FleetioFaq() {
  const { t } = useTranslation("fleetio");

  return (
    <section aria-labelledby="fleetio-faq-title" className="mt-8 mb-12 text-[#1E1F22]">
      <div className="wrap">
        <h2
          id="fleetio-faq-title"
          className="font-display mx-auto mt-16 mb-6 max-w-[200px] text-center text-2xl leading-[1.1] font-extrabold md:mx-0 md:max-w-none md:text-[32px] lg:mt-24 lg:text-left"
        >
          {t("faq.title")}
        </h2>
        <Accordion type="single" collapsible className="flex flex-col gap-4">
          {FAQ_ITEMS.map((key) => (
            <AccordionItem key={key} value={key} className="overflow-hidden rounded-lg border border-[#DFDFDF] bg-white">
              <AccordionTrigger
                data-sid={`fleetio-faq-trigger:${key}`}
                className="gap-2 p-6 pr-3 text-left font-normal tracking-normal text-[#1E1F22] lg:pr-6"
              >
                <span>{t(`faq.items.${key}.question`)}</span>
              </AccordionTrigger>
              <AccordionContent className="max-w-[740px] pt-0 pr-6 pb-6 pl-10 text-sm text-[#1E1F22]">
                {t(`faq.items.${key}.answer`)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}

export default FleetioFaq;
